import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useUser } from '../../../../hooks/use-user';
import { UserRole, UserType } from '../../../../lib/interfaces/user';
import CourseBuilderPage from './page';

const CourseBuilderWrapper = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    if (!user) return;
    if (user.userType !== UserType.Internal || user.userRole === UserRole.User) {
      navigate('/', { replace: true });
    }
  }, [user, navigate]);

  if (!id) return null;

  return (
    <div className="flex flex-col gap-5 h-full">
      <CourseBuilderPage courseId={id} />
    </div>
  );
};

export default CourseBuilderWrapper;
